import { Headphones, Lightbulb, ListChecks, type LucideIcon, Sparkles } from "lucide-preact";
import { Section, SectionHeading } from "./Section";

type Step = { icon: LucideIcon; title: string; text: string };

const STEPS: Step[] = [
  { icon: ListChecks, title: "The big picture in five lines", text: "Short on time? The five-point summary at the top gives you the gist in about a minute." },
  {
    icon: Lightbulb,
    title: "Three ideas, explained properly",
    text: "Then each idea gets room to breathe, with plain words and a clear takeaway at the end of it.",
  },
  { icon: Sparkles, title: "A tidy ending", text: "Every article closes by pulling it all together, so you finish with a clear picture." },
  { icon: Headphones, title: "Read it or hear it", text: "Pick a narrator you like and listen hands-free, or switch back to reading whenever you want." },
];

const StepRow = ({ icon: Icon, title, text }: Step, index: number) => (
  <li key={title} class="flex gap-4">
    <span class="shrink-0 inline-flex w-10 h-10 items-center justify-center rounded-full bg-gradient-to-br from-blue-600 to-purple-600 text-white font-bold">
      {index + 1}
    </span>
    <div>
      <h3 class="flex items-center gap-2 text-lg font-bold text-gray-900 dark:text-gray-50">
        {title}
        <Icon class="w-4 h-4 text-purple-500" />
      </h3>
      <p class="mt-1 text-gray-600 dark:text-gray-300">{text}</p>
    </div>
  </li>
);

export const Inside = () => (
  <Section>
    <SectionHeading title="Short, but never shallow" intro="Every article follows the same friendly shape, so you always know what you are getting." />
    <ol class="grid gap-8 md:grid-cols-2 max-w-4xl mx-auto">{STEPS.map(StepRow)}</ol>
  </Section>
);
